import { storableError } from '../../util/errors';

export const FETCH_STORES_REQUEST = 'app/AdminPage/FETCH_STORES_REQUEST';
export const FETCH_STORES_SUCCESS = 'app/AdminPage/FETCH_STORES_SUCCESS';
export const FETCH_STORES_ERROR = 'app/AdminPage/FETCH_STORES_ERROR';

export const FETCH_STORE_REQUEST = 'app/AdminPage/FETCH_STORE_REQUEST';
export const FETCH_STORE_SUCCESS = 'app/AdminPage/FETCH_STORE_SUCCESS';
export const FETCH_STORE_ERROR = 'app/AdminPage/FETCH_STORE_ERROR';

export const FETCH_LISTINGS_REQUEST = 'app/AdminPage/FETCH_LISTINGS_REQUEST';
export const FETCH_LISTINGS_SUCCESS = 'app/AdminPage/FETCH_LISTINGS_SUCCESS';
export const FETCH_LISTINGS_ERROR = 'app/AdminPage/FETCH_LISTINGS_ERROR';

export const ACTIVATE_LISTINGS_REQUEST = 'app/AdminPage/ACTIVATE_LISTINGS_REQUEST';
export const ACTIVATE_LISTINGS_SUCCESS = 'app/AdminPage/ACTIVATE_LISTINGS_SUCCESS';
export const ACTIVATE_LISTINGS_ERROR = 'app/AdminPage/ACTIVATE_LISTINGS_ERROR';

export const DEACTIVATE_LISTINGS_REQUEST = 'app/AdminPage/DEACTIVATE_LISTINGS_REQUEST';
export const DEACTIVATE_LISTINGS_SUCCESS = 'app/AdminPage/DEACTIVATE_LISTINGS_SUCCESS';
export const DEACTIVATE_LISTINGS_ERROR = 'app/AdminPage/DEACTIVATE_LISTINGS_ERROR';

export const MIGRATE_STORES_REQUEST = 'app/AdminPage/MIGRATE_STORES_REQUEST';
export const MIGRATE_STORES_SUCCESS = 'app/AdminPage/MIGRATE_STORES_SUCCESS';
export const MIGRATE_STORES_ERROR = 'app/AdminPage/MIGRATE_STORES_ERROR';

export const RESET_ADMIN_PAGE = 'app/AdminPage/RESET_ADMIN_PAGE';


// Actions
export const fetchStoreRequest = () => ({ type: FETCH_STORE_REQUEST });
export const fetchStoreSuccess = store => ({ type: FETCH_STORE_SUCCESS, payload: store });
export const fetchStoreError = error => ({ type: FETCH_STORE_ERROR, error });

export const fetchListingsRequest = () => ({ type: FETCH_LISTINGS_REQUEST });
export const fetchListingsSuccess = listings => ({ type: FETCH_LISTINGS_SUCCESS, payload: listings });
export const fetchListingsError = error => ({ type: FETCH_LISTINGS_ERROR, error });

export const activateListingsRequest = () => ({ type: ACTIVATE_LISTINGS_REQUEST });
export const activateListingsSuccess = updatedListings => ({ type: ACTIVATE_LISTINGS_SUCCESS, payload: updatedListings });
export const activateListingsError = error => ({ type: ACTIVATE_LISTINGS_ERROR, error });

export const deactivateListingsRequest = () => ({ type: DEACTIVATE_LISTINGS_REQUEST });
export const deactivateListingsSuccess = updatedListings => ({ type: DEACTIVATE_LISTINGS_SUCCESS, payload: updatedListings });
export const deactivateListingsError = error => ({ type: DEACTIVATE_LISTINGS_ERROR, error });

export const migrateStoresRequest = () => ({ type: MIGRATE_STORES_REQUEST });
export const migrateStoresSuccess = updatedListings => ({ type: MIGRATE_STORES_SUCCESS, payload: updatedListings });
export const migrateStoresError = error => ({ type: MIGRATE_STORES_ERROR, error });

export const resetAdminPage = () => ({ type: RESET_ADMIN_PAGE });

// Thunks

export const fetchStore = storeId => async dispatch => {
  dispatch(fetchStoreRequest());
  try {
    const urlStoreUser = `${process.env.REACT_APP_API_ROOT_URL.replace(/\/$/, '')}/api/storeUser`;
    //console.log("urlStoreUser", urlStoreUser)
    const response = await fetch(urlStoreUser, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ storeId }),
    });
    const data = await response.json();
    if (data.success) {
      dispatch(fetchStoreSuccess(data.user));
      return data.user;
    } else {
      throw new Error(data.error);
    }
  } catch (e) {
    dispatch(fetchStoreError(e));
    throw e;
  }
};

/*
export const fetchStore = storeId => (dispatch, getState, sdk) => {
  dispatch(fetchStoreRequest());
  return sdk.users.show({ id: storeId })
    .then(response => {
      console.log("response.data.data", response.data.data)
      dispatch(fetchStoreSuccess(response.data.data));
      return response.data.data;
    })
    .catch(e => {
      dispatch(fetchStoreError(storableError(e)));
      throw e;
    });
};
*/

/*
export const fetchStoreListings = storeId => (dispatch, getState, sdk) => {
  dispatch(fetchListingsRequest());
  return sdk.listings.query({
    authorId: storeId,
    pub_isProduct: true,
    include: ['author', 'images'],
    perPage: 100,
  })
    .then(response => {
      dispatch(fetchListingsSuccess(response.data.data));
      return response.data.data;
    })
    .catch(e => {
      dispatch(fetchListingsError(storableError(e)));
      throw e;
    });
};
*/
export const fetchStoreListings = storeId => async dispatch => {
  dispatch(fetchListingsRequest());
  try {
    const urlStoreListings = `${process.env.REACT_APP_API_ROOT_URL.replace(/\/$/, '')}/api/storeListings`;
    const response = await fetch(urlStoreListings, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ storeId }),
    });
    const data = await response.json();
    if (data.success) {
      dispatch(fetchListingsSuccess(data.listings));
      return data.listings;
    } else {
      throw new Error(data.error);
    }
  } catch (e) {
    dispatch(fetchListingsError(e));
    throw e;
  }
};
/*
export const deactivateStoreListings = storeId => async (dispatch, getState, sdk) => {
  dispatch(deactivateListingsRequest());
  try {
    // Traer todos los listings activos de la tienda
    const response = await sdk.listings.query({
      authorId: storeId,
      pub_isProduct: true,
      pub_isActive: true,
      perPage: 100,
    });
    const listings = response.data.data;

    // Desactivar cada listing
    const updatePromises = listings.map(listing =>
      sdk.listings.update({
        id: listing.id.uuid,
        publicData: {
          ...listing.attributes.publicData,
          isActive: false,
        },
      })
    );

    const updatedListings = await Promise.all(updatePromises);
    dispatch(deactivateListingsSuccess(updatedListings.map(r => r.data.data)));
    return updatedListings.map(r => r.data.data);
  } catch (e) {
    dispatch(deactivateListingsError(storableError(e)));
    throw e;
  }
};
*/

export const activateStoreListings = storeId => async dispatch => {
  dispatch(activateListingsRequest());
  try {
    const urlActivateStoreListings = `${process.env.REACT_APP_API_ROOT_URL.replace(/\/$/, '')}/api/activateStoreListings`;
    const response = await fetch(urlActivateStoreListings, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ storeId }),
    });
    const data = await response.json();
    if (data.success) {
      //console.log("🦄", data)
      dispatch(activateListingsSuccess(data.updatedListings));
      dispatch(fetchStoreSuccess(data.updatedStore));
      return data.updatedListings;
    } else {
      throw new Error(data.error);
    }
  } catch (e) {
    dispatch(activateListingsError(e));
    throw e;
  }
};

export const migrateStores = storeId => async dispatch => {
  dispatch(migrateStoresRequest());
  try {
    const urlActivateStoreListings = `${process.env.REACT_APP_API_ROOT_URL.replace(/\/$/, '')}/api/migrateStores`;
    const response = await fetch(urlActivateStoreListings, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ storeId }),
    });
    const data = await response.json();
    if (data.success) {
      //console.log("🦄", data)
      dispatch(activateListingsSuccess(data.updatedListings));
      dispatch(fetchStoreSuccess(data.updatedStore));
      return data.updatedListings;
    } else {
      throw new Error(data.error);
    }
  } catch (e) {
    dispatch(activateListingsError(e));
    throw e;
  }
};


/*
export const activateStoreListings = storeId => async (dispatch, getState, sdk) => {
  dispatch(activateListingsRequest());
  try {
    // Traer todos los listings inactivos y productos de la tienda
    const response = await sdk.listings.query({
      authorId: storeId,
      pub_isProduct: true,
      pub_isActive: false,
      perPage: 100,
    });
    const listings = response.data.data;

    // Activar cada listing
    const updatePromises = listings.map(listing =>
      sdk.listings.update({
        id: listing.id.uuid,
        publicData: {
          ...listing.attributes.publicData,
          isActive: true,
        },
      })
    );

    const updatedListings = await Promise.all(updatePromises);
    dispatch(activateListingsSuccess(updatedListings.map(r => r.data.data)));
    return updatedListings.map(r => r.data.data);
  } catch (e) {
    dispatch(activateListingsError(storableError(e)));
    throw e;
  }
};
*/
export const deactivateStoreListings = storeId => async dispatch => {
  dispatch(deactivateListingsRequest());
  try {
    const urlDeactivateStoreListings = `${process.env.REACT_APP_API_ROOT_URL.replace(/\/$/, '')}/api/deactivateStoreListings`;
    const response = await fetch(urlDeactivateStoreListings, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ storeId }),
    });
    const data = await response.json();
    if (data.success) {
      //console.log("🦄", data)
      dispatch(deactivateListingsSuccess(data.updatedListings));
      dispatch(fetchStoreSuccess(data.updatedStore));
      return data.updatedListings;
    } else {
      throw new Error(data.error);
    }
  } catch (e) {
    dispatch(deactivateListingsError(e));
    throw e;
  }
};

export const fetchStores = (params = {}) => async dispatch => {
  dispatch({ type: FETCH_STORES_REQUEST });

  try {
    const queryParams = {
      perPage: params.perPage || 100,
      page: params.page || 1,
      ...params
    };

    //console.log('🔍 Buscando tiendas oficiales con parámetros:', queryParams);

    const urlFetchStores = `${process.env.REACT_APP_API_ROOT_URL.replace(/\/$/, '')}/api/fetchStores`;
    const response = await fetch(urlFetchStores, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(queryParams),
    });

    const data = await response.json();

    if (data.success) {
      //console.log('✅ Tiendas oficiales encontradas:', data.stores.length);
      //console.log('📊 Respuesta completa:', data);
      
      dispatch({
        type: FETCH_STORES_SUCCESS,
        payload: {
          stores: data.stores,
          pagination: data.pagination,
        },
      });
      
      return data;
    } else {
      throw new Error(data.error || 'Error al obtener tiendas');
    }

  } catch (error) {
    //console.error('❌ Error buscando tiendas oficiales:', error);
    dispatch({
      type: FETCH_STORES_ERROR,
      payload: error,
    });
    throw error;
  }
};

export const fetchAllStores = (params = {}) => async dispatch => {
  dispatch({ type: FETCH_STORES_REQUEST });
//alert("asd")
  try {
    const queryParams = {
      getAllStores: true, // ✅ Parámetro clave para cargar todas
      searchTerm: params.searchTerm || '',
      onlyActive: params.onlyActive || false,
      includePrivateData: true,
      ...params
    };

    //console.log('🔍 Cargando TODAS las tiendas oficiales...');

    const urlFetchStores = `${process.env.REACT_APP_API_ROOT_URL.replace(/\/$/, '')}/api/fetchStores`;
    const response = await fetch(urlFetchStores, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(queryParams),
    });

    const data = await response.json();

    if (data.success) {
      //console.log('✅ TODAS las tiendas oficiales cargadas:', data.stores.length);
      //console.log('📊 Estadísticas:', data.stats);
      
      dispatch({
        type: FETCH_STORES_SUCCESS,
        payload: {
          stores: data.stores,
          pagination: data.pagination,
          stats: data.stats,
          meta: data.meta
        },
      });
      
      return data;
    } else {
      throw new Error(data.error || 'Error al obtener todas las tiendas');
    }

  } catch (error) {
    //console.error('❌ Error cargando todas las tiendas:', error);
    dispatch({
      type: FETCH_STORES_ERROR,
      payload: error,
    });
    throw error;
  }
};
/*
export const migrateStores = (params = {}) => async dispatch => {
  dispatch({ type: MIGRATE_STORES_REQUEST });

  try {
    const migrationParams = {
      migrateAll: params.migrateAll || false,
      storeIds: params.storeIds || [],
      dryRun: params.dryRun || false,
      ...params
    };

    console.log('🔄 Iniciando migración de tiendas:', migrationParams);

    const urlMigrateStores = `${process.env.REACT_APP_API_ROOT_URL.replace(/\/$/, '')}/api/migrateStores`;
    const response = await fetch(urlMigrateStores, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(migrationParams),
    });

    const data = await response.json();

    if (data.success) {
      console.log('✅ Migración completada:', data.stats);
      
      dispatch({
        type: MIGRATE_STORES_SUCCESS,
        payload: {
          results: data.results,
          stats: data.stats,
          migrationDate: data.migrationDate,
          meta: data.meta
        },
      });
      
      return data;
    } else {
      throw new Error(data.error || 'Error en la migración');
    }

  } catch (error) {
    console.error('❌ Error en migración:', error);
    dispatch({
      type: MIGRATE_STORES_ERROR,
      payload: error,
    });
    throw error;
  }
};
*/

export const clearStores = () => ({
  type: 'app/AdminPage/CLEAR_STORES'
});

// Reducer
const initialState = {
  store: null,
  listings: [],
  stores: [],
  loadingStore: false,
  loadingListings: false,
  loadingStores: false,
  deactivating: false,
  error: null,
  deactivateError: null,
  storesError: null,
  pagination: null,
  migrating: false, 
  migrationResults: null,
  migrationError: null,
};

export default function adminPageReducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_STORE_REQUEST:
      return { ...state, loadingStore: true, error: null };
    case FETCH_STORE_SUCCESS:
      return { ...state, loadingStore: false, store: action.payload };
    case FETCH_STORE_ERROR:
      return { ...state, loadingStore: false, error: action.error };

    case FETCH_LISTINGS_REQUEST:
      return { ...state, loadingListings: true, error: null };
    case FETCH_LISTINGS_SUCCESS:
      return { ...state, loadingListings: false, listings: action.payload };
    case FETCH_LISTINGS_ERROR:
      return { ...state, loadingListings: false, error: action.error };

    case ACTIVATE_LISTINGS_REQUEST:
      return { ...state, activating: true, activateError: null };
    case ACTIVATE_LISTINGS_SUCCESS:
      return { ...state, activating: false, listings: action.payload };
    case ACTIVATE_LISTINGS_ERROR:
      return { ...state, activating: false, activateError: action.error };

    case DEACTIVATE_LISTINGS_REQUEST:
      return { ...state, deactivating: true, deactivateError: null };
    case DEACTIVATE_LISTINGS_SUCCESS:
      return { ...state, deactivating: false, listings: action.payload };
    case DEACTIVATE_LISTINGS_ERROR:
      return { ...state, deactivating: false, deactivateError: action.error };
    
    case MIGRATE_STORES_REQUEST:
      return {
        ...state,
        migrating: true,
        migrationError: null,
      };

    case MIGRATE_STORES_SUCCESS:
      return {
        ...state,
        migrating: false,
        migrationResults: action.payload,
        migrationError: null,
      };

    case MIGRATE_STORES_ERROR:
      return {
        ...state,
        migrating: false,
        migrationError: action.payload,
        migrationResults: null,
      };

    case FETCH_STORES_REQUEST:
      return { 
        ...state, 
        loadingStores: true, 
        storesError: null, 
      };

    case FETCH_STORES_SUCCESS:
      return { 
        ...state, 
        loadingStores: false, 
        stores: action.payload.stores,        // ✅ Usar action.payload
        pagination: action.payload.pagination, // ✅ Usar action.payload
        storesError: null, 
      };

    case FETCH_STORES_ERROR:
      return { 
        ...state, 
        loadingStores: false, 
        storesError: action.payload,  // ✅ Usar action.payload
        stores: [], 
        pagination: null, 
      };



    case 'app/AdminPage/CLEAR_STORES':
      return {  ...state, stores: [], pagination: null, storesError: null, };
    case RESET_ADMIN_PAGE:
      return {
        ...initialState,
        store: null,
        listings: [],
        error: null,
        activateError: null,
        deactivateError: null,
        loadingStore: false,
        loadingListings: false,
        activating: false,
        deactivating: false,
      };
    default:
      return state;
  }
}